import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Truck } from "../../../types";
import VehicleTable from "../../tables/VehicleTable/VehicleTable";

interface DevTabContentProps {
  devTrucks: Truck[];
  hitOrMiss: string;
  setHitOrMiss: (value: string) => void;
  token?: string;
  deleteTruck: (truck: Truck) => void;
  updateTruck: (truck: Truck) => void;
  updateEntryDirection: (truck: Truck, direction: "in" | "out") => void;
  updateLicensePlate: (truck: Truck, newLicensePlate: string) => void;
}

export function DevTabContent({
  devTrucks,
  hitOrMiss,
  setHitOrMiss,
  token,
  deleteTruck,
  updateTruck,
  updateEntryDirection,
  updateLicensePlate,
}: DevTabContentProps): React.JSX.Element {
  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant={hitOrMiss === "hit" ? "contained" : "outlined"}
          onClick={() => setHitOrMiss("hit")}
          sx={{ mr: 1 }}
        >
          Hit
        </Button>
        <Button
          variant={hitOrMiss === "miss" ? "contained" : "outlined"}
          onClick={() => setHitOrMiss("miss")}
        >
          Miss
        </Button>
      </Box>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        {devTrucks.length} vehicle{devTrucks.length !== 1 ? "s" : ""} found
      </Typography>
      <VehicleTable
        trucks={devTrucks}
        index={1}
        token={token}
        deleteTruck={deleteTruck}
        updateTruck={updateTruck}
        updateEntryDirection={updateEntryDirection}
        updateLicensePlate={updateLicensePlate}
      />
    </>
  );
}
